import { useCallback, useEffect, useState } from "react";
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle } from "../../bootstrap/Modal";
import Button from "../../bootstrap/Button";
import useFetch from "../../../hooks/useFetch";
import FormGroup from "../../bootstrap/forms/FormGroup";
import Select, { ActionMeta } from 'react-select';
import { ReactSelectStyles } from '../../../utils/styles';
import useFilters from "../../../hooks/useFilters";
import { OfficeService } from "../../../services/ofiice/officeService";
import { Office } from "../../../type/office-type";

type CampaignOfficeSelectorModalProps = {
    isOpen: boolean;
    setIsOpen: (value: boolean) => void;
    onClose: Function;
    defaultSelected?: string | null;
    isMulti?: boolean;
    discardSelected?: boolean;
    isRequired?: boolean;
}

const CampaignOfficeSelectorModal: React.FC<CampaignOfficeSelectorModalProps> = ({ isOpen, setIsOpen, onClose, defaultSelected, isMulti, discardSelected, isRequired}) => {
    
    const [selectedOption, setSelectedOption] = useState<string[]|string|null>(null);

    const { filters, updateFilters, resetFilters, updateFilterOrder, updatePage, updatePageSize } = useFilters({active : true}, [], 9999999);

    const [data] = useFetch(
        useCallback(async () => {
            const service = new OfficeService();
            const response = await service.getOffices(filters);
            return response.getResponseData();
        }, [])
    )

    const _getOptions = (): any[] => {
        let options: any = [];
        if (data) {
            data.offices.forEach((item: Office) => {
                // if discardSelected is true, discard selected options for not appear in the list
                if(discardSelected && defaultSelected && defaultSelected.length > 0) {
                    let found = defaultSelected == item.id;
                    if(found) {
                        return;
                    }
                }
                options.push({ value: item.id, label: item.name });
            })
        }
        return options;
    }

    const _getDefaultSelectedValues = (): any => {
        let option = null;
        if (selectedOption && data) {
            let optionData = data.offices.filter((item: Office) => selectedOption.includes(item.id));
            option = optionData.map((item: Office) => ({ value: item.id, label: item.name }));
        }
        return option;
    }

    const _handleChange = (newValue: any, actionMeta: ActionMeta<any>) => {
        if (Array.isArray(newValue)) {
            let selected = newValue.map((option: any) => option.value);
            setSelectedOption(selected);
        } else {
            setSelectedOption(newValue.value);
        }
    }

    const _notifyChange = () => {
        setIsOpen(false);
        onClose(selectedOption);
    }

    return (
        <>
            <Modal isOpen={isOpen} setIsOpen={setIsOpen} onClose={_notifyChange} size={'lg'}>
                <ModalHeader setIsOpen={setIsOpen}>
                    <ModalTitle id="modal-allowed-statuses">Añadir oficina</ModalTitle>
                </ModalHeader>
                <ModalBody>
                <FormGroup label='Oficinas' requiredInputLabel={isRequired} color={'primary'}>
                    <Select styles={ReactSelectStyles} placeholder="Elige una oficina"
                        name={"Oficinas"} isMulti={isMulti} options={_getOptions()} value={_getDefaultSelectedValues()} onChange={_handleChange} />
                </FormGroup>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={_notifyChange}>Guardar</Button>
                </ModalFooter>
            </Modal>
        </>
    );
};


export default CampaignOfficeSelectorModal;